// Lucide icon resolver — used by content-driven sections
import { Zap, ShieldCheck, Sparkles, Banknote, Wallet, Home, Briefcase, Building2, FileText, Truck, RotateCcw, BadgeCheck, LineChart, Layers, Heart, Users, Phone, Mail, MessageCircle, MapPin, Star, CheckCircle2, Calculator, TrendingUp, Award, Target, Clock, IndianRupee, ArrowRight, Linkedin, Twitter, Facebook, Instagram, Youtube, Globe, Github, Send } from "lucide-react";

const MAP = { Zap, ShieldCheck, Sparkles, Banknote, Wallet, Home, Briefcase, Building2, FileText, Truck, RotateCcw, BadgeCheck, LineChart, Layers, Heart, Users, Phone, Mail, MessageCircle, MapPin, Star, CheckCircle2, Calculator, TrendingUp, Award, Target, Clock, IndianRupee, ArrowRight, Linkedin, Twitter, Facebook, Instagram, Youtube, Globe, Github, Send };

export const SOCIAL_ICONS = ["Linkedin", "Twitter", "Facebook", "Instagram", "Youtube", "Github", "Send", "Globe", "MessageCircle"];

export function Icon({ name, ...props }) {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp {...props} />;
}
export const ICON_NAMES = Object.keys(MAP);
